import { render, staticRenderFns } from "./SectorsAdd.vue?vue&type=template&id=38848a50&scoped=true&"
import script from "./SectorsAdd.vue?vue&type=script&lang=js&"
export * from "./SectorsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38848a50",
  null
  
)

export default component.exports